import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import rootReducer from "./reducers";
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import callAPIMiddleware from './middlewares/callApiMiddleware';
import { registerTranslations } from './utils/languages/registerTranslations';
import { customPolyfill } from './utils/customPolifylls';
import { IAuthReducerState } from './reducers/authReducer';
import { ILoginReducerState } from './reducers/loginReducer';
import { initAuthData } from './actions/authActions';
import { IIntercomReducer } from './reducers/intercomReducer';
import { IUsersReducerState } from './reducers/usersReducer'; 
import { ICompaniesReducerState } from './reducers/companiesReducer';
import { IFreeTrialReducerState } from './reducers/freeTrialsReducer';


customPolyfill();
registerTranslations();

const composeEnhancers =
  typeof window === 'object' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk, callAPIMiddleware)
)


// export store to make dispatch() fn globally available
export const reduxStore = createStore(
  rootReducer,
  enhancer
);

export interface AppState {
  auth: IAuthReducerState,
  login: ILoginReducerState,
  intercom: IIntercomReducer,
  users: IUsersReducerState,
  companies: ICompaniesReducerState,
  freeTrials: IFreeTrialReducerState
}

// INITIALIZE AUTHENTICATION DATA FOR THE USER
reduxStore.dispatch(initAuthData());


ReactDOM.render(
  <Provider store={reduxStore}>
    <App />
  </Provider>,
  document.getElementById('root') || document.createElement('div') // for testing purposes
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
